module.exports = __webpack_public_path__ + "static/media/human-female-boy.d8ff1641.svg";